import { useCart } from '../../../contexts/CartContext';

export const useCartOperations = () => {
  const { 
    cart, 
    addToCart, 
    addGift,
    removeFromCart, 
    removeGift,
    updateQuantity, 
    clearCart,
    getCartTotal, 
    getDiscountedCartTotal,
    discountAmt,
    setDiscountAmt,
    getCartCount,
    paidItems,
    giftItems,
    selectedCountry, 
    selectedCurrency,
    updateCountry,
    demoData,
    COUNTRIES 
  } = useCart();

  return {
    cart,
    addToCart,
    addGift,
    removeFromCart,
    removeGift,
    updateQuantity,
    clearCart,
    getCartTotal,
    getDiscountedCartTotal,
    discountAmt,
    setDiscountAmt,
    getCartCount,
    paidItems,
    giftItems,
    selectedCountry,
    selectedCurrency,
    updateCountry,
    demoData,
    COUNTRIES
  };
};
